import { create } from 'zustand'
import { dashboardApi, DashboardData, DashboardParams } from '../services/dashboardApi'

interface DashboardState {
  data: DashboardData | null
  loading: boolean
  error: string | null
}

interface DashboardActions {
  fetchDashboardData: (params?: DashboardParams) => Promise<void>
  clearError: () => void
  reset: () => void
}

type DashboardStore = DashboardState & DashboardActions

const initialState: DashboardState = {
  data: null,
  loading: false,
  error: null,
}

export const useDashboardStore = create<DashboardStore>((set) => ({
  ...initialState,

  fetchDashboardData: async (params?: DashboardParams) => {
    set({ loading: true, error: null })
    try {
      const response = await dashboardApi.getDashboardData(params)
      if (response.success && response.data) {
        set({ data: response.data, loading: false })
      } else {
        set({ error: 'Failed to fetch dashboard data', loading: false })
      }
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'Failed to fetch dashboard data',
        loading: false 
      })
    }
  },

  clearError: () => set({ error: null }),

  reset: () => set(initialState),
}))

